import React from "react"
import PropTypes from "prop-types"
import { Div, ImgWrapper, Img, P } from "./styles"

const Avatar = ({
  src,
  alt,
  size,
  smallOnMobile,
  firstName,
  lastName,
  avatarExists,
  plain,
  obfuscated,
  noBorder,
  profile
}) => {
  const initials = firstName?.charAt(0)?.toUpperCase() + lastName?.charAt(0)?.toUpperCase()
  const hideAvatar = !avatarExists || !!obfuscated

  if (hideAvatar) {
    return (
      <Div alt={alt} size={size} smallOnMobile={smallOnMobile} plain={plain} noBorder={noBorder} profile={profile}>
        <P size={size} smallOnMobile={smallOnMobile} profile={profile}>
          {initials}
        </P>
      </Div>
    )
  } else {
    return (
      <ImgWrapper size={size} smallOnMobile={smallOnMobile}>
        <Img src={src} alt={alt} />
      </ImgWrapper>
    )
  }
}

Avatar.propTypes = {
  src: PropTypes.string,
  alt: PropTypes.string,
  size: PropTypes.oneOf(["small", "default", "medium", "large"]),
  smallOnMobile: PropTypes.bool,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  avatarExists: PropTypes.bool,
  plain: PropTypes.bool,
  obfuscated: PropTypes.bool,
  noBorder: PropTypes.bool
}

Avatar.defaultProps = {
  alt: "",
  size: "default",
  smallOnMobile: false,
  firstName: "",
  lastName: "",
  avatarExists: false,
  obfuscated: false,
  noBorder: false
}

export default Avatar
